import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Tabs,
  Tab,
  Paper,
  Divider,
  CircularProgress,
  Alert,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SendIcon from "@mui/icons-material/Send";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import config from "../../config/config";
import { useAuth } from "../login/AuthContext";
import { toast } from "react-toastify";
import "./SistemMesajlari.css";

const HEDEF_OPTIONS = [
  { value: "tumu", label: "Tümü" },
  { value: "altin", label: "Altın Bayi" },
  { value: "gumus", label: "Gümüş Bayi" },
  { value: "bronz", label: "Bronz Bayi" },
  { value: "secimli", label: "Seçimli (Bayi seçin)" },
];

const TIP_LABELS = {
  sistem: "Sistem",
  siparis_olusturma: "Sipariş Oluşturma",
  siparis_yonlendirme: "Sipariş Yönlendirme",
  siparis_onay: "Sipariş Onay",
};

function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
}

export default function SistemMesajlari() {
  const { token, userData } = useAuth();
  const [bildirimler, setBildirimler] = useState([]);
  const [okunmamisSayisi, setOkunmamisSayisi] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingSayi, setLoadingSayi] = useState(true);
  const [tab, setTab] = useState(0);

  const isAnaBayi = userData?.BayiKodu === 1;

  const [sistemMesajBaslik, setSistemMesajBaslik] = useState("");
  const [sistemMesajIcerik, setSistemMesajIcerik] = useState("");
  const [hedefTip, setHedefTip] = useState("tumu");
  const [secilenBayiIds, setSecilenBayiIds] = useState([]);
  const [popUpGoster, setPopUpGoster] = useState(false);
  const [popUpBaslangic, setPopUpBaslangic] = useState("");
  const [popUpBitis, setPopUpBitis] = useState("");
  const [popUpResimler, setPopUpResimler] = useState([]);
  const [popUpKlasorListe, setPopUpKlasorListe] = useState([]);
  const [popUpKlasorYukleniyor, setPopUpKlasorYukleniyor] = useState(false);
  const [popUpKlasorHata, setPopUpKlasorHata] = useState(null);
  const [popUpResimYukleniyor, setPopUpResimYukleniyor] = useState(false);
  const popUpResimInputRef = useRef(null);
  const [bayiListesi, setBayiListesi] = useState([]);
  const [sistemMesajlarListe, setSistemMesajlarListe] = useState([]);
  const [sistemMesajGonderiliyor, setSistemMesajGonderiliyor] = useState(false);
  const [sistemMesajListeYukleniyor, setSistemMesajListeYukleniyor] = useState(false);
  const [tarihBaslangic, setTarihBaslangic] = useState("");
  const [tarihBitis, setTarihBitis] = useState("");
  const [detayBildirim, setDetayBildirim] = useState(null);
  const [detaySistemMesaj, setDetaySistemMesaj] = useState(null);

  const axiosConfig = { headers: { Authorization: `Bearer ${token}` } };

  const downloadResim = (url, defaultFilename = "resim.jpg") => {
    if (!url) return;
    const filename = (url.split("/").pop() || defaultFilename).split("?")[0] || defaultFilename;
    fetch(url, { credentials: "include" })
      .then((r) => r.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
      })
      .catch(() => window.open(url, "_blank"));
  };

  const getResimFullUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    // Pop-up resmi: canlıda /api/uploads proxy'de olmayabilir; /api/bildirim/pop-up-resim kullan (Node'a gider)
    const m = (path || "").match(/\/api\/uploads\/pop-up\/([^/]+)$/);
    if (m) return `${config.baseURL}/bildirim/pop-up-resim/${encodeURIComponent(m[1])}`;
    if (path.startsWith("/") && typeof window !== "undefined")
      return window.location.origin + path;
    const base = config.baseURL.replace(/\/api\/?$/, "");
    return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  };

  const fetchPopUpKlasor = useCallback(async () => {
    if (!token) return;
    setPopUpKlasorYukleniyor(true);
    setPopUpKlasorHata(null);
    try {
      const res = await axios.get(`${config.baseURL}/bildirim/sistem-mesaj/pop-up-klasor`, axiosConfig);
      if (res.data?.success && Array.isArray(res.data.data)) {
        setPopUpKlasorListe(res.data.data);
        setPopUpKlasorHata(null);
      } else {
        setPopUpKlasorListe([]);
        setPopUpKlasorHata(null);
      }
    } catch (err) {
      setPopUpKlasorListe([]);
      const status = err.response?.status;
      const msg = err.response?.data?.message || err.message;
      setPopUpKlasorHata(status === 404 ? "Bu adres sunucuda yok (404). Backend güncel mi?" : status === 403 ? "Yetki yok (sadece ana bayi)." : msg || "Liste alınamadı. Backend çalışıyor mu?");
    } finally {
      setPopUpKlasorYukleniyor(false);
    }
  }, [token]);

  const handlePopUpResimToggle = (url) => {
    setPopUpResimler((prev) => {
      if (prev.includes(url)) return prev.filter((u) => u !== url);
      if (prev.length >= 10) return prev;
      return [...prev, url];
    });
  };

  const handlePopUpResimEkle = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;
    if (!token) {
      toast.error("Oturum bulunamadı. Lütfen tekrar giriş yapın.");
      e.target.value = "";
      return;
    }
    if (popUpResimler.length + files.length > 10) {
      toast.warning("En fazla 10 resim seçebilirsiniz.");
      e.target.value = "";
      return;
    }
    setPopUpResimYukleniyor(true);
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) formData.append("resimler", files[i]);
    const headers = { Authorization: `Bearer ${token}` };
    const urlsToTry = [
      `${config.baseURL}/upload-popup-resim`,
      `${config.baseURL}/sistem-mesaj-upload-resim`,
      `${config.baseURL}/bildirim/sistem-mesaj/upload-resim`,
    ];
    let ok = false;
    for (const url of urlsToTry) {
      try {
        const res = await axios.post(url, formData, { headers });
        if (res.data?.success && res.data.urls?.length) {
          toast.success(`${res.data.urls.length} resim pop-up klasörüne eklendi.`);
          fetchPopUpKlasor();
          ok = true;
          break;
        }
      } catch (err) {
        if (err.response?.status !== 404) break;
      }
    }
    if (!ok) toast.error("Resim yüklenemedi. Backend çalışıyor mu?");
    setPopUpResimYukleniyor(false);
    e.target.value = "";
  };

  const tarihFilterRef = useRef({ tarihBaslangic: "", tarihBitis: "" });
  tarihFilterRef.current = { tarihBaslangic, tarihBitis };

  const fetchBildirimler = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const params = new URLSearchParams({ limit: "100" });
      const { tarihBaslangic: b, tarihBitis: e } = tarihFilterRef.current;
      if (b) params.set("baslangic", b);
      if (e) params.set("bitis", e);
      const res = await axios.get(`${config.baseURL}/bildirim?${params.toString()}`, axiosConfig);
      if (res.data?.success) {
        setBildirimler(res.data.data || []);
      }
    } catch (err) {
      toast.error("Bildirimler yüklenemedi.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchOkunmamisSayisi = useCallback(async () => {
    if (!token) return;
    setLoadingSayi(true);
    try {
      const res = await axios.get(`${config.baseURL}/bildirim/okunmamis-sayisi`, axiosConfig);
      if (res.data?.success) setOkunmamisSayisi(res.data.count ?? 0);
    } catch (_) {
      setOkunmamisSayisi(0);
    } finally {
      setLoadingSayi(false);
    }
  }, [token]);

  useEffect(() => {
    fetchBildirimler();
    fetchOkunmamisSayisi();
  }, [fetchBildirimler, fetchOkunmamisSayisi]);

  const handleOkundu = async (id) => {
    try {
      await axios.put(`${config.baseURL}/bildirim/${id}/okundu`, {}, axiosConfig);
      fetchBildirimler();
      fetchOkunmamisSayisi();
    } catch (err) {
      toast.error("İşlem başarısız.");
    }
  };

  const handleTumunuOkundu = async () => {
    try {
      await axios.put(`${config.baseURL}/bildirim/tumunu-okundu`, {}, axiosConfig);
      fetchBildirimler();
      fetchOkunmamisSayisi();
      toast.success("Tüm bildirimler okundu işaretlendi.");
    } catch (err) {
      toast.error("İşlem başarısız.");
    }
  };

  useEffect(() => {
    if (!isAnaBayi || hedefTip !== "secimli") return;
    axios
      .get(`${config.baseURL}/bildirim/sistem-mesaj/bayi-listesi`, axiosConfig)
      .then((res) => {
        if (res.data?.success) setBayiListesi(res.data.data || []);
      })
      .catch(() => setBayiListesi([]));
  }, [isAnaBayi, hedefTip, token]);

  const fetchSistemMesajlari = useCallback(async () => {
    if (!isAnaBayi || !token) return;
    setSistemMesajListeYukleniyor(true);
    try {
      const res = await axios.get(`${config.baseURL}/bildirim/sistem-mesaj?limit=50`, axiosConfig);
      if (res.data?.success) setSistemMesajlarListe(res.data.data || []);
    } catch (_) {
      setSistemMesajlarListe([]);
    } finally {
      setSistemMesajListeYukleniyor(false);
    }
  }, [isAnaBayi, token]);

  useEffect(() => {
    if (isAnaBayi && tab === 1) fetchSistemMesajlari();
  }, [isAnaBayi, tab, fetchSistemMesajlari]);

  useEffect(() => {
    if (popUpGoster && token) fetchPopUpKlasor();
    else {
      setPopUpKlasorListe([]);
      setPopUpKlasorHata(null);
    }
  }, [popUpGoster, token, fetchPopUpKlasor]);

  const handleSistemMesajSil = async (id) => {
    if (!window.confirm("Bu sistem mesajını silmek istediğinize emin misiniz? İlgili bildirimler de silinir.")) return;
    try {
      const res = await axios.delete(`${config.baseURL}/bildirim/sistem-mesaj/${id}`, axiosConfig);
      if (res.data?.success) {
        toast.success(res.data.message || "Silindi.");
        fetchSistemMesajlari();
      } else toast.error(res.data?.message || "Silinemedi.");
    } catch (err) {
      toast.error(err.response?.data?.message || "Silinemedi.");
    }
  };

  const handleSistemMesajAktif = async (id, aktif) => {
    try {
      const res = await axios.put(
        `${config.baseURL}/bildirim/sistem-mesaj/${id}/aktif`,
        { aktif },
        { ...axiosConfig, headers: { ...axiosConfig.headers, "Content-Type": "application/json" } }
      );
      if (res.data?.success) {
        toast.success(res.data.message || (aktif ? "Aktif edildi." : "Pasif edildi."));
        fetchSistemMesajlari();
      } else toast.error(res.data?.message || "Güncellenemedi.");
    } catch (err) {
      toast.error(err.response?.data?.message || "Güncellenemedi.");
    }
  };

  const handleSistemMesajGonder = async () => {
    if (!sistemMesajBaslik?.trim()) {
      toast.warning("Başlık zorunludur.");
      return;
    }
    setSistemMesajGonderiliyor(true);
    try {
      const payload = {
        baslik: sistemMesajBaslik.trim(),
        icerik: sistemMesajIcerik.trim() || "",
        hedefTip,
        bayiIds: hedefTip === "secimli" ? secilenBayiIds : undefined,
        popUpGoster: popUpGoster || undefined,
        popUpBaslangic: popUpGoster && popUpBaslangic ? popUpBaslangic : undefined,
        popUpBitis: popUpGoster && popUpBitis ? popUpBitis : undefined,
        popUpResimler: popUpGoster && popUpResimler?.length > 0 ? popUpResimler : undefined,
      };
      const res = await axios.post(`${config.baseURL}/bildirim/sistem-mesaj`, payload, {
        ...axiosConfig,
        headers: { ...axiosConfig.headers, "Content-Type": "application/json" },
      });
      if (res.data?.success) {
        toast.success(res.data.message || "Sistem mesajı gönderildi.");
        setSistemMesajBaslik("");
        setSistemMesajIcerik("");
        setSecilenBayiIds([]);
        setHedefTip("tumu");
        setPopUpGoster(false);
        setPopUpBaslangic("");
        setPopUpBitis("");
        setPopUpResimler([]);
        fetchSistemMesajlari();
        fetchBildirimler();
        fetchOkunmamisSayisi();
      } else {
        toast.error(res.data.message || "Gönderilemedi.");
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Sistem mesajı gönderilemedi.";
      const detail = err.response?.data?.error;
      toast.error(detail ? `${msg} (${detail})` : msg);
    } finally {
      setSistemMesajGonderiliyor(false);
    }
  };

  const formatDate = (d) => {
    if (!d) return "";
    const date = new Date(d);
    return date.toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <Box className="sistem-mesajlari-page">
      <Typography variant="h5" sx={{ mb: 2, color: "var(--primary-color)", fontWeight: 600 }}>
        Sistem Mesajları
      </Typography>

      {isAnaBayi && (
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{
            borderBottom: "1px solid #e0e0e0",
            mb: 2,
            "& .MuiTab-root": { fontWeight: 600 },
            "& .Mui-selected": { color: "var(--primary-color)" },
          }}
        >
          <Tab label="Bildirim Kutusu" icon={<NotificationsIcon />} iconPosition="start" />
          <Tab label="Sistem Mesajı Oluştur" icon={<SendIcon />} iconPosition="start" />
        </Tabs>
      )}

      <TabPanel value={tab} index={0}>
        <Card className="bildirim-kutusu-card" sx={{ borderRadius: 2, boxShadow: 2 }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} sx={{ mb: 2 }}>
              <Typography variant="h6" sx={{ color: "var(--primary-color)" }}>
                Bildirimlerim
                {okunmamisSayisi > 0 && (
                  <Chip
                    label={okunmamisSayisi}
                    size="small"
                    color="primary"
                    sx={{ ml: 1 }}
                  />
                )}
              </Typography>
              {okunmamisSayisi > 0 && (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<MarkEmailReadIcon />}
                  onClick={handleTumunuOkundu}
                  sx={{ borderColor: "var(--primary-color)", color: "var(--primary-color)" }}
                >
                  Tümünü okundu işaretle
                </Button>
              )}
            </Box>
            <Box display="flex" flexWrap="wrap" gap={2} sx={{ mb: 2 }}>
              <TextField
                size="small"
                label="Başlangıç tarihi"
                type="date"
                value={tarihBaslangic}
                onChange={(e) => setTarihBaslangic(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 160 }}
              />
              <TextField
                size="small"
                label="Bitiş tarihi"
                type="date"
                value={tarihBitis}
                onChange={(e) => setTarihBitis(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 160 }}
              />
              <Button
                variant="contained"
                size="small"
                onClick={fetchBildirimler}
                sx={{ alignSelf: "flex-end", bgcolor: "var(--primary-color)" }}
              >
                Filtrele
              </Button>
            </Box>
            {loading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress sx={{ color: "var(--primary-color)" }} />
              </Box>
            ) : bildirimler.length === 0 ? (
              <Alert severity="info">Henüz bildirim yok.</Alert>
            ) : (
              <Box sx={{ maxHeight: 420, overflow: "auto" }} className="bildirim-list-scroll">
                <List disablePadding>
                  {bildirimler.map((b) => (
                    <ListItem
                      key={b.Id}
                      className={b.Okundu ? "bildirim-item okundu" : "bildirim-item"}
                      button
                      onClick={() => setDetayBildirim(b)}
                      sx={{ cursor: "pointer" }}
                      secondaryAction={
                        !b.Okundu && (
                          <IconButton
                            edge="end"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOkundu(b.Id);
                            }}
                            title="Okundu işaretle"
                          >
                            <CheckCircleOutlineIcon fontSize="small" />
                          </IconButton>
                        )
                      }
                    >
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <NotificationsIcon
                          fontSize="small"
                          sx={{ color: b.Okundu ? "#9e9e9e" : "var(--primary-color)" }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={b.Baslik}
                        secondary={
                          <>
                            <Typography component="span" variant="body2" color="text.secondary">
                              {b.Icerik ? (b.Icerik.length > 80 ? b.Icerik.slice(0, 80) + "…" : b.Icerik) : ""}
                            </Typography>
                            <Typography component="span" variant="caption" display="block" color="text.secondary">
                              {TIP_LABELS[b.Tip] || b.Tip} · {b.CreatedAtTr || formatDate(b.CreatedAt)}
                            </Typography>
                          </>
                        }
                        primaryTypographyProps={{
                          fontWeight: b.Okundu ? 400 : 600,
                          color: b.Okundu ? "text.secondary" : "text.primary",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </CardContent>
        </Card>
      </TabPanel>

      {isAnaBayi && (
        <TabPanel value={tab} index={1}>
          <Paper elevation={2} sx={{ p: 3, borderRadius: 2, maxWidth: 640 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, color: "var(--primary-color)", fontWeight: 600 }}>
              Yeni sistem mesajı
            </Typography>
            <TextField
              fullWidth
              label="Başlık"
              value={sistemMesajBaslik}
              onChange={(e) => setSistemMesajBaslik(e.target.value)}
              required
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="İçerik"
              value={sistemMesajIcerik}
              onChange={(e) => setSistemMesajIcerik(e.target.value)}
              multiline
              rows={3}
              sx={{ mb: 2 }}
            />
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Hedef</InputLabel>
              <Select
                value={hedefTip}
                label="Hedef"
                onChange={(e) => setHedefTip(e.target.value)}
              >
                {HEDEF_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value}>
                    {o.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {hedefTip === "secimli" && (
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Bayiler</InputLabel>
                <Select
                  multiple
                  value={secilenBayiIds}
                  label="Bayiler"
                  onChange={(e) => setSecilenBayiIds(e.target.value)}
                  renderValue={(selected) =>
                    selected
                      .map((id) => bayiListesi.find((b) => b.Id === id)?.BayiAdi || id)
                      .join(", ")
                  }
                >
                  {bayiListesi.map((b) => (
                    <MenuItem key={b.Id} value={b.Id}>
                      {b.BayiAdi} {b.KomisyonTier ? `(${b.KomisyonTier})` : ""}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={popUpGoster}
                  onChange={(e) => setPopUpGoster(e.target.checked)}
                  sx={{ color: "var(--primary-color)", "&.Mui-checked": { color: "var(--primary-color)" } }}
                />
              }
              label="Pop-up olarak ekranda göster"
              sx={{ mb: 1 }}
            />
            {popUpGoster && (
              <>
                <Box sx={{ mb: 2, pl: 2, display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
                  <Typography variant="body2" color="text.secondary" sx={{ alignSelf: "center" }}>
                    Gösterilecek tarih aralığı:
                  </Typography>
                  <TextField
                    type="date"
                    label="Başlangıç"
                    value={popUpBaslangic}
                    onChange={(e) => setPopUpBaslangic(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    sx={{ minWidth: 160 }}
                  />
                  <TextField
                    type="date"
                    label="Bitiş"
                    value={popUpBitis}
                    onChange={(e) => setPopUpBitis(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    sx={{ minWidth: 160 }}
                  />
                </Box>
                <Box sx={{ mb: 2, pl: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      Resim ekle / Resim seç (pop-up klasörü; 5 saniyede bir kayar):
                    </Typography>
                    <input
                      ref={popUpResimInputRef}
                      type="file"
                      accept="image/jpeg,image/png,image/gif,image/webp"
                      multiple
                      style={{ display: "none" }}
                      onChange={handlePopUpResimEkle}
                    />
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<PhotoLibraryIcon />}
                      onClick={() => popUpResimInputRef.current?.click()}
                      disabled={popUpResimYukleniyor}
                      sx={{ borderColor: "var(--primary-color)", color: "var(--primary-color)" }}
                    >
                      {popUpResimYukleniyor ? "Yükleniyor..." : "Resim ekle"}
                    </Button>
                    <Button size="small" variant="outlined" onClick={fetchPopUpKlasor} disabled={popUpKlasorYukleniyor}>
                      Listeyi yenile
                    </Button>
                  </Box>
                  <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 1 }}>
                    Resim ekle ile dosyalar <strong>uploads/pop-up</strong> klasörüne kaydedilir. Aşağıdan hangilerinin pop-up’ta gösterileceğini seçin.
                  </Typography>
                  {popUpKlasorYukleniyor ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <CircularProgress size={20} />
                      <Typography variant="caption">Klasör listeleniyor...</Typography>
                    </Box>
                  ) : popUpKlasorHata ? (
                    <Box>
                      <Typography variant="caption" color="error" display="block" sx={{ mb: 1 }}>
                        {popUpKlasorHata}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                        Yerel test: Backend (node server) çalışıyor olmalı ve <code>server/uploads/pop-up</code> klasöründe .jpg/.png dosyaları olmalı.
                      </Typography>
                      <Button size="small" variant="outlined" onClick={fetchPopUpKlasor} disabled={popUpKlasorYukleniyor}>
                        Listeyi yenile
                      </Button>
                    </Box>
                  ) : popUpKlasorListe.length === 0 ? (
                    <Box>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                        Klasörde resim yok. Resimleri <strong>sunucunun</strong> <strong>uploads/pop-up</strong> klasörüne atın (yerel: server/uploads/pop-up). Sonra &quot;Listeyi yenile&quot;ye basın.
                      </Typography>
                      <Button size="small" variant="outlined" onClick={fetchPopUpKlasor} disabled={popUpKlasorYukleniyor}>
                        Listeyi yenile
                      </Button>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {popUpKlasorListe.map((url) => (
                        <Box
                          key={url}
                          onClick={() => handlePopUpResimToggle(url)}
                          sx={{
                            position: "relative",
                            width: 72,
                            height: 72,
                            borderRadius: 1,
                            overflow: "hidden",
                            border: "2px solid",
                            borderColor: popUpResimler.includes(url) ? "var(--primary-color)" : "#ddd",
                            cursor: "pointer",
                            opacity: popUpResimler.includes(url) ? 1 : 0.85,
                          }}
                        >
                          <img
                            src={getResimFullUrl(url)}
                            alt=""
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                          {popUpResimler.includes(url) && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                width: 20,
                                height: 20,
                                borderRadius: "50%",
                                bgcolor: "var(--primary-color)",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                              }}
                            >
                              ✓
                            </Box>
                          )}
                        </Box>
                      ))}
                    </Box>
                  )}
                  {popUpResimler.length > 0 && (
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
                      Seçilen: {popUpResimler.length} / 10 resim
                    </Typography>
                  )}
                </Box>
              </>
            )}
            <Button
              variant="contained"
              startIcon={<SendIcon />}
              onClick={handleSistemMesajGonder}
              disabled={
                sistemMesajGonderiliyor ||
                !sistemMesajBaslik?.trim() ||
                (popUpGoster && (!popUpBaslangic || !popUpBitis))
              }
              sx={{
                bgcolor: "var(--primary-color)",
                "&:hover": { bgcolor: "var(--secondary-color)" },
              }}
            >
              {sistemMesajGonderiliyor ? "Gönderiliyor..." : "Gönder"}
            </Button>
          </Paper>

          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
              Gönderilen sistem mesajları
            </Typography>
            {sistemMesajListeYukleniyor ? (
              <Box display="flex" justifyContent="center" py={2}>
                <CircularProgress size={24} />
              </Box>
            ) : sistemMesajlarListe.length === 0 ? (
              <Alert severity="info">Henüz gönderilmiş sistem mesajı yok.</Alert>
            ) : (
              <List component={Paper} variant="outlined" sx={{ borderRadius: 1 }}>
                {sistemMesajlarListe.map((m) => (
                  <ListItem
                    key={m.Id}
                    divider
                    button
                    onClick={() => setDetaySistemMesaj(m)}
                    sx={{ cursor: "pointer" }}
                    secondaryAction={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }} onClick={(e) => e.stopPropagation()}>
                        <Chip
                          label={m.Aktif !== false ? "Aktif" : "Pasif"}
                          size="small"
                          color={m.Aktif !== false ? "success" : "default"}
                          sx={{ mr: 0.5 }}
                        />
                        <Switch
                          checked={m.Aktif !== false}
                          onChange={() => handleSistemMesajAktif(m.Id, m.Aktif === false)}
                          size="small"
                          color="primary"
                          title={m.Aktif !== false ? "Pasif yap" : "Aktif yap"}
                        />
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleSistemMesajSil(m.Id)}
                          title="Sil"
                        >
                          <DeleteOutlineIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    }
                  >
                    <ListItemText
                      primary={m.Baslik}
                      secondary={`${m.HedefTip} · ${formatDate(m.CreatedAt)}`}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        </TabPanel>
      )}

      {/* Bildirim detay penceresi */}
      <Dialog
        open={Boolean(detayBildirim)}
        onClose={() => setDetayBildirim(null)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        {detayBildirim && (
          <>
            <DialogTitle sx={{ fontWeight: 600, color: "var(--primary-color)" }}>
              {detayBildirim.Baslik}
            </DialogTitle>
            <DialogContent dividers>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {TIP_LABELS[detayBildirim.Tip] || detayBildirim.Tip} · {detayBildirim.CreatedAtTr || formatDate(detayBildirim.CreatedAt)}
              </Typography>
              {(() => {
                const resimler = Array.isArray(detayBildirim.PopUpResimler)
                  ? detayBildirim.PopUpResimler
                  : typeof detayBildirim.PopUpResimler === "string"
                    ? (() => { try { return JSON.parse(detayBildirim.PopUpResimler) || []; } catch { return []; } })()
                    : [];
                return resimler.length > 0 ? (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                    {resimler.map((path, idx) => {
                      const src = getResimFullUrl(path);
                      return (
                        <Box key={idx} sx={{ position: "relative", display: "inline-block" }}>
                          <Box
                            component="img"
                            src={src}
                            alt={`Ek ${idx + 1}`}
                            sx={{ maxWidth: "100%", maxHeight: 280, objectFit: "contain", borderRadius: 1, border: "1px solid #eee" }}
                            onError={(e) => { e.target.style.display = "none"; }}
                          />
                          <IconButton
                            onClick={() => downloadResim(src, `ek-${idx + 1}.jpg`)}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              bgcolor: "rgba(255,255,255,0.9)",
                              "&:hover": { bgcolor: "white" },
                            }}
                            size="small"
                            aria-label="İndir"
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Box>
                      );
                    })}
                  </Box>
                ) : null;
              })()}
              <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                {detayBildirim.Icerik || "—"}
              </Typography>
            </DialogContent>
            <DialogActions>
              {!detayBildirim.Okundu && (
                <Button
                  startIcon={<CheckCircleOutlineIcon />}
                  onClick={() => {
                    handleOkundu(detayBildirim.Id);
                    setDetayBildirim((prev) => (prev ? { ...prev, Okundu: true } : null));
                  }}
                >
                  Okundu işaretle
                </Button>
              )}
              <Button onClick={() => setDetayBildirim(null)} variant="contained">
                Kapat
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Sistem mesajı detay penceresi */}
      <Dialog
        open={Boolean(detaySistemMesaj)}
        onClose={() => setDetaySistemMesaj(null)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        {detaySistemMesaj && (
          <>
            <DialogTitle sx={{ fontWeight: 600, color: "var(--primary-color)" }}>
              {detaySistemMesaj.Baslik}
            </DialogTitle>
            <DialogContent dividers>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Hedef: {detaySistemMesaj.HedefTip || "—"} · {formatDate(detaySistemMesaj.CreatedAt)}
              </Typography>
              {(() => {
                const resimler = Array.isArray(detaySistemMesaj.PopUpResimler)
                  ? detaySistemMesaj.PopUpResimler
                  : typeof detaySistemMesaj.PopUpResimler === "string"
                    ? (() => { try { return JSON.parse(detaySistemMesaj.PopUpResimler) || []; } catch { return []; } })()
                    : [];
                return resimler.length > 0 ? (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                    {resimler.map((path, idx) => {
                      const src = getResimFullUrl(path);
                      return (
                        <Box key={idx} sx={{ position: "relative", display: "inline-block" }}>
                          <Box
                            component="img"
                            src={src}
                            alt={`Ek ${idx + 1}`}
                            sx={{ maxWidth: "100%", maxHeight: 240, objectFit: "contain", borderRadius: 1, border: "1px solid #eee" }}
                            onError={(e) => { e.target.style.display = "none"; }}
                          />
                          <IconButton
                            onClick={() => downloadResim(src, `ek-${idx + 1}.jpg`)}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              bgcolor: "rgba(255,255,255,0.9)",
                              "&:hover": { bgcolor: "white" },
                            }}
                            size="small"
                            aria-label="İndir"
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Box>
                      );
                    })}
                  </Box>
                ) : null;
              })()}
              <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                {detaySistemMesaj.Icerik || "—"}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDetaySistemMesaj(null)} variant="contained">
                Kapat
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
}
